module.exports = __webpack_public_path__ + "img/icons/new/minus-white-8cf55a9e3ede0e0a1aab41aa5af3a050.svg";